import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Company } from 'mbs-ui-shared@models';

export const companyNameUniqueValidator =
  (companies: () => Company[], currentName: () => string, message: () => string): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null => {
    if (!control.touched || !companies().length || control.value === currentName()) return null;

    return companies().some((company) => company.name === control.value) ? { isBusy: { message: message() } } : null;
  };
